import axios from 'axios';

import {TOKEN_EXPIRED, TIMEOUT, INTERNAL_ERROR, INVALID_USER_FOR_SITE} from "../hooks/useAPIHelper";

const SYS_GET_USERS = '/.netlify/functions/sysGetUsers';

const SysGetUsers = async (userID: string, token: string) => {

  const fetchData = async (): Promise<any> => {
    try {
      let userDataResponse = await axios.post(SYS_GET_USERS, userID, {
        headers: {
          'Content-Type': 'application/json',
          'X-Pronto-Token': token,
        }
      });

      if (userDataResponse != undefined) {
        if (userDataResponse.status == 200) {
          return userDataResponse.data.SysGetUsersResponse.Users.User.UserName;
        }
      }
    } catch (err) {
      if (err == undefined) {
        return 'Unknown error!'
      } else {
        if (err.response.status == 401) {
          if (err.response.data == 'TokenExpired') {
            throw(TOKEN_EXPIRED)
          }
        } else if (err.response.status == 504) {
          throw(TIMEOUT);
        } else if (err.response.status == 500) {
          throw(INTERNAL_ERROR);
        } else if (err.response.status == 502) {
          throw(INVALID_USER_FOR_SITE);
        }
      }
    }
  }

  return await fetchData();
};

export default SysGetUsers;